module.exports = __webpack_public_path__ + "static/media/sv-podium-bg.15e33e62.png";